import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const FireIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                d='M14.1279 20.2355C14.1279 21.5796 13.6776 22.4964 12.8629 22.8773C11.9966 23.1299 11.2412 22.9202 10.9551 22.8893C10.1473 22.5327 8.98367 20.9566 10.8098 19.5103C11.469 18.9595 12.2098 18.3416 12.312 16.4439C12.9187 16.9922 14.1279 18.3243 14.1279 20.2354L14.1279 20.2355ZM9.85417 1C11.6477 4.64452 10.5193 6.59967 10.5193 6.59967C10.5193 6.59967 9.12282 5.67413 8.58917 5.43177C9.01542 7.41263 8.76104 9.94354 7.20213 10.9558C0.932125 15.807 5.8787 20.7715 7.87331 21.9008C7.19613 21.0698 5.28655 17.9639 9.13231 15.5148C13.076 12.9798 10.7548 9.82232 10.7548 9.82232C10.7548 9.82232 13.8795 9.28864 16.7267 15.3542C17.8087 18.4573 16.6219 20.8705 16.1037 21.7274C18.5074 20.1462 19.8694 17.2405 19.8694 14.3453C19.8703 5.95427 11.4097 1.01373 9.85435 1.00009L9.85417 1Z'
                fill='currentColor'
            />
        </>
    ),
})

FireIcon.displayName = 'FireIcon'
